class ProductDetailUpsellItem extends Component {
	constructor(el) {
		super(el);
		this.moreLink = this.$find('[data-show-more]');
		this.moreLink.addEventListener('click', () => this.toggleContent());
	}

	toggleContent() {
		this.$el.classList.toggle('is-active');
	}
}